import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, forkJoin, of } from 'rxjs';
import { DimensionUnits, EnvironmentConfig } from 'src/app/models/environment-config.model';
import { CloudPriceListing } from 'src/app/models/cloud-price-listing';
import { SingleEnvironmentDetails } from 'src/app/models/single-environment-details.model';
import { CouponPricing } from 'src/app/models/coupon-pricing.model';
import { Support24x7 } from 'src/app/models/support24x7.model';
import Helper from 'src/app/Util/helper';
import { environment } from 'src/environments/environment';
import { VirtualMachineCostRequest } from 'src/app/interfaces/vm.interface';
import { HttpService } from 'src/app/http.service';


enum Color {
  Green = "green",
  Red = "red"
}
@Injectable({
  providedIn: 'root'
})


export class CostcalculatorService {

  private twintyFour7 = `https://fakerapi.it/api/v1/custom?_quantity=1&Twinty47Suppport=boolean`
  private MonthlyMachinesCost = `https://fakerapi.it/api/v1/custom?_quantity=1&MSsftWareCost=number&MInfrastructureCost=number&MDataCost=number`
  private YearlyMachinesCost = `https://fakerapi.it/api/v1/custom?_quantity=1&YSsftWareCost=number&YInfrastructureCost=number&YDataCost=number`
  private Coupon = `https://fakerapi.it/api/v1/custom?_quantity=1&CouponCode=postcode&CouponExpiration=date_time&CouponValue=buildingNumber`


  constructor(private http: HttpService) { }

  get247Support(): Observable<any> {
    return this.http.get(this.twintyFour7);
  }

  getMonthlyMachinesCost(): Observable<any> {
    return this.http.get(this.MonthlyMachinesCost);
  }

  getYearlyMachinesCost(): Observable<any> {
    return this.http.get(this.YearlyMachinesCost);
  }

  getCoupon(): Observable<any> {
    return this.http.get(this.Coupon);
  }

  getTotalCost(): Observable<any> {
    return forkJoin({
      twinty47Support: this.get247Support(),
      monthlyCost: this.getMonthlyMachinesCost(),
      yearlyCost: this.getYearlyMachinesCost(),
      coupon: this.getCoupon()
    });
  }

  calculateCost(units: DimensionUnits): number {
    // const totalCost = (units?.data * this.dataPricing) + (units?.software * this.softwarePricing) + (units?.managementFee * this.softwarePricing) + (units?.infrastructure * this.infrastructurePricing)
    // return Helper.roundToDecimals(totalCost, 3)
    let a = Number(20); // or just 'let a = 20;'
    return a;
  }

  getVMPriceListByEnv(subscirptionId: string, envName: string): Observable<CloudPriceListing[]> {
    // var route = Helper.formatString(environment.api.routes.pricing.get_vm_price_list_by_env, subscirptionId, envName)
    // return this.http.get(route);

    return of(null)

  }


  getAppliedCoupon(env: SingleEnvironmentDetails, subscriptionId: string): Observable<CouponPricing> {
    // return this.http.get<CouponPricing>(environment.api.routes.pricing.get_applied_coupon_cost, {
    //   ...env, subscriptionId: subscriptionId
    // })

    return of(null)
  }

   

  confirmCost(vm:any){
    const request = {
      CloudVendor: 'AWS',
      Region: 'us-west-2',
      AvailabilityZone: 'us-west-2a',
      ServerPlan:"ENt" , // Matches enum value
      NCacheVersion: '5.2.0',
      Edition: 'Enterprise', // Matches enum value
      OS: 'Windows' // Matches enum value
    };
    return this.http.post<any>(environment.api.routes.pricing.confirm_cost,request);
  }

  calculateSupport24x7(monthlyUnits: number, annualUnits: number, monthlyMachines: number, annualMachines: number) {
    // var monthlyCost = monthlyUnits * this.softwarePricing;
    // var annualCost = annualUnits * this.softwarePricing;
    // return (monthlyCost * monthlyMachines) + (annualCost * annualMachines);

    let a = Number(20); // or just 'let a = 20;'
    return a;

  }

  getExistingEnvironment24x7Cost(subscriptionId: string): Observable<number> {
    // var apiUrl = Helper.formatString(environment.api.routes.pricing.get_support_247_existing, subscriptionId)
    // return this.http.get<number>(apiUrl)
    let a = Number(20); // or just 'let a = 20;'
    return of(a);

  }

  calculateCostPerDimension(units: number, type: string): number {
    if (type == "data") {
      return units * 10
    }
    else if (type == "software") {
      return units * 20
    }
    else {
      return units * 30
    }
  }

  check24x7Support(): Observable<Support24x7> {
    // return this.http.get(environment.api.routes.user.can_subscribe_to_24x7);

    let data: Support24x7 = {
      canSubscribeTo24x7: true
    }
    return of(data)

  }




}
